import React from 'react'

function DeliveryAppHome() {
  return (
  
<div className="p-6 bg-gray-100 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Delivery Route Optimisation App
      </h1>
      <p className="text-gray-700 mb-4">
        This app, built using <span className="font-semibold">React Native</span> and{' '}
        <span className="font-semibold">Mapbox</span>, addresses a real-world challenge I encountered during my Sunday parcel delivery job.
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">The Problem</h2>
      <p className="text-gray-700 mb-4">
        The company's delivery route optimiser often generated inefficient routes, such as revisiting the same road—or even neighbouring
        houses—multiple times during a single trip. This inefficiency motivated me to create an app to generate better-optimised routes.
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">How it Works</h2>
      <p className="text-gray-700 mb-4">
        The app lets users search for and add addresses to a delivery route, plotting them on an interactive map. Once the addresses are
        entered, the app stores them and sends the data to the <span className="font-semibold">Mapbox Optimisation API</span> to generate an optimised
        route.
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">Challenges</h2>
      <p className="text-gray-700 mb-4">
        The API returned coordinates instead of exact addresses, which required me to write a custom algorithm to match the coordinates with
        their respective addresses. The algorithm then reordered the route accordingly, and the map updated with numbered markers for clear navigation.
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">Additional Features</h2>
      <ul className="list-disc pl-6 text-gray-700 mb-4">
        <li>Assign multiple parcels to each address.</li>
        <li>
          Add photos of parcel types (e.g., Amazon boxes) to help identify packages for quicker deliveries.
        </li>
      </ul>
      <p className="text-gray-700">
        This project not only solved a real-life inefficiency but also enhanced my understanding of route optimisation and custom algorithm
        development.
      </p>
    </div>

)
}

export default DeliveryAppHome